<template>
	<div class="mainMap">
		<div class="maskTitle">
			<span>地点</span>
            <!-- <el-select style="width:80%;" placeholder="请输入关键词" v-model="value" size="small" filterable remote :remote-method="remoteMethod">
                <el-option v-for="(item, index) in addressLists" :key="index" :label="item.address" :value="item.id"></el-option>
            </el-select> -->
			<span @click="close"><i class="el-icon-close"></i></span>
		</div>
		<div class="block" id="container"></div>
	</div>
</template>

<script>
    import { TMap } from "../../../../static/js/tencertMap.js"
    import config from "@/common/env.js"

    export default {
        name: "mapMask",
        props: ["lng", "lat", "mapIndex"],
        data() {
            return {
                key: "OV6BZ-MN7CD-EWA4C-PHQRX-XGWQZ-HSFCG",
                value: null,
                addressLists: [],

            }
        },
        mounted() {
            this.initMap();
        },
        methods: {
            initMap() {
                let _this = this;
                TMap(this.key).then(qq => {
                    let lng = this.lng;
                    let lat = this.lat;
                    // 第一步，初始化地图
                    let center = new qq.maps.LatLng(lat, lng);
                    let map = new qq.maps.Map(document.getElementById("container"), {
                        center: center,
                        zoom: 13,
                    });
                    //第二步，初始marker
                    let marker = new qq.maps.Marker({
                        position: center,
                        map: map,
                    });
                    let anchor = new qq.maps.Point(10, 37);
                    let size = new qq.maps.Size(42, 68);
                    let origin = new qq.maps.Point(0, 0);
                    let markerIcon = new qq.maps.MarkerImage(
                        "https://3gimg.qq.com/lightmap/api_v2/2/4/99/theme/default/imgs/marker.png",
                        size,
                        origin,
                        anchor
                    );
                    marker.setIcon(markerIcon);
                    
                    qq.maps.event.addListener(map, "click", function (e) {
                        // console.log(e)
                        _this.getAddress(e.latLng)
                    })
                })
            },

            getAddress(e) {//https://lbs.qq.com/service/webService/webServiceGuide/webServiceSearch  https://lbs.qq.com/service/webService/webServiceGuide/webServiceGcoder  https://zhuanlan.zhihu.com/p/376287904
                // console.log(e)
                let _this = this;
                // let url = "https://apis.map.qq.com/ws/place/v1/search";
                // this.$jsonp(url, {
                //     key: _this.key,
                //     boundary: `region(${config.configuration.cityData}, 0)`,
                //     keyword: e,
                //     output: "jsonp",
                // }).then(res => {
                //     // console.log(res)
                //     let { status, data } = res;
                //     if(status == 0) {
                //         console.log(data)
                //     }
                // })
                let url = "https://apis.map.qq.com/ws/geocoder/v1/";
                this.$jsonp(url, {
                    key: _this.key,
                    location: `${e.lat},${e.lng}`,
                    output: "jsonp",
                }).then(res => {
                    console.log(res)
                    let { status, result, message } = res;
                    if(status == 0) {
                        console.log(result.address)
                        let addressStr = result.address;
                        let index = _this.mapIndex;
                        this.$emit("hideMap", {addressStr, index});
                    } else {
                        _this.$message.error(message);
                    }
                })
            },

            selectAddress(e) {
				// AMap.plugin("AMap.Autocomplete", function() {
				// 	new AMap.Autocomplete({
				// 		city: config.configuration.cityData,
				// 	}).search(e, function(status, result) {
				// 		console.log(result)
				// 		if (status == "complete") {
				// 		}
				// 	})
				// })
			},

            remoteMethod(e) {
                console.log(e)
                let _this = this;
                if(e != "") {
                    let url = "https://apis.map.qq.com/ws/place/v1/search";
                    this.$jsonp(url, {
                        key: _this.key,
                        boundary: `region(${config.configuration.cityData}, 0)`,
                        keyword: e,
                        page_size: 20,
                        output: "jsonp",
                    }).then(res => {
                        // console.log(res)
                        let { status, data } = res;
                        if(status == 0) {
                            console.log(data)
                            _this.addressLists = data;
                        }
                    })
                }
            },

            close() {
                this.$emit("hideMap");
            },

        }
    }
</script>

<style lang="scss" scoped>
    .mainMap {
        /*width: 100vw;*/
        /*height: 100vh;*/
        display: flex;
        background: #fff;
        flex-direction: row;
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        z-index: 101;
        flex-direction: column;
        box-sizing: border-box;

        .maskTitle {
            padding: 10px;
            box-sizing: border-box;
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: calc(100%);
            box-sizing: border-box;
            background: #ccc;
            z-index: 102;
        }
    }
</style>



// WEBPACK FOOTER //
// map.vue?f77b36a8